var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedErrorExclamationmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_212",
    "data-name": "Group 212",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8d191d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(16 25)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "Raleway-SemiBold, Raleway",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.55,
    y: 0
  }, "!"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedErrorExclamationmark);
export default __webpack_public_path__ + "static/media/red-error-exclamationmark.ae608edbbf8e95b07060518646f04af5.svg";
export { ForwardRef as ReactComponent };